import WindowModal from './WindowModal';
import CampingAjaxForm from '../forms/CampingAjaxForm';
import { ContentProviderAjaxDjangoFetch, RESPONSE_JSON_WITH_HTML } from '../lib/modals/content_providers/ContentProviderAjax';

class AjaxFormModal extends WindowModal {

  /*
  contentElements = {
    form_fields_container_selector: string
  }
  */
  constructor(ajaxUrl, ajaxFormClass=CampingAjaxForm, contentElements={'form_fields_container_selector': '#modalResponseContainer'}) {
    super(new ContentProviderAjaxDjangoFetch(ajaxUrl, {method: 'GET'}, RESPONSE_JSON_WITH_HTML));
    this.ajaxFormClass = ajaxFormClass;
    this.form = null;
    this.contentElements = contentElements;
  }

  initContent() {
    super.initContent();
    const formElements = {
      form: this.elements.modal_content.querySelector('form'),
      form_fields_container: this.elements.modal_content.querySelector(this.contentElements.form_fields_container_selector),
    };
    if (this.elements.modal_content.querySelector('#messageContainer')) {
      formElements.message_container = this.elements.modal_content.querySelector('#messageContainer');
    }
    this.form = new this.ajaxFormClass(formElements, this);
  }

  uninitContent() {
    super.uninitContent();
    this.form.unInit();
  }

}

export default AjaxFormModal;



// WEBPACK FOOTER //
// ./src/js/modals/AjaxFormModal.js